import {
  Box,
  Button,
  FormControl,
  Grid,
  Skeleton,
  TextField,
  Typography,
  Paper,
  InputLabel,
  Select,
  List,
  MenuItem,
  Alert
} from "@mui/material";
import { useState } from "react";
import PaymentsService from "../../services/payment.service";
import CloseIcon from '@mui/icons-material/Close';

function MercadoPagoApi() {
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState(null);
  const [alert, setAlert] = useState(false);
  const [alertDescription, setAlertDescription] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) {
      setAlert(true)
      setAlertDescription("El ID de pago no puede estar vacío.");
      return;
    }

    if (typeOfPayment == null) {
      setAlert(true)
      setAlertDescription("Por favor seleccione un tipo de pago.");
      return;
    }

    try {
      setLoader(true);
      const res = typeOfPayment == 1 ? await PaymentsService.getExternalInfoMpPayment(inputValue.trim()) : await PaymentsService.getExternalInfoPayPalPayment(inputValue.trim());

      // Nos aseguramos de que tiene la estructura esperada
      if (res?.mpRes && res?.storedPayment) {
        setResult(res);
      } else {
        setResult(null);
      }
    } catch (err) {
      console.error("Error al consultar el pago:", err);
      setAlertDescription("No se encontraron resultados.");
      setAlert(true);
      setResult(null);
    } finally {
      setLoader(false);
    }
  };


  const [typeOfPayment, setTypeOfPayment] = useState(null);
  const handleChange = (event) => {
    setTypeOfPayment(event.target.value);
  };


  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "60%",
        minWidth: 400,
        maxHeight: "80vh",
        overflow: "auto",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        borderRadius: 2,
        p: 4,
      }}
    >

      <FormControl component="form" onSubmit={handleSubmit} fullWidth>
        <Box display="flex" alignItems="center" mb={3}>
          <TextField
            fullWidth
            label="ID de pago"
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />


          <FormControl style={{ marginLeft: 16, width: 250 }}>
            <InputLabel id="payment-type-label">Tipo de Pago</InputLabel>
            <Select
              labelId="payment-type-label"
              id="demo-simple-select"
              value={typeOfPayment}
              label="Tipo de Pago"
              onChange={handleChange}
            >
              <MenuItem value={1}>MercadoPago</MenuItem>
              <MenuItem value={2}>PayPal</MenuItem>
            </Select>
          </FormControl>


          <Button type="submit" variant="contained" style={{ marginLeft: 16 }}>
            Buscar
          </Button>
        </Box>
      </FormControl>


      {loader ? (
        <Skeleton variant="rectangular" width="100%" height={300} />
      ) : result ? (
        <>
          <Typography variant="h6" gutterBottom>
            🧾 Información del Pago
          </Typography>
          <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography><strong>ID:</strong> {result?.mpRes?.id}</Typography>
                <Typography><strong>Estado:</strong> {result?.mpRes?.status}</Typography>
                <Typography><strong>Detalle:</strong> {result?.mpRes?.status_detail || result?.mpRes?.links[0]?.href}</Typography>
                <Typography><strong>Monto:</strong> ${result?.mpRes?.transaction_amount || result?.mpRes?.purchase_units[0]?.amount?.value}</Typography>
                <Typography><strong>Moneda:</strong> {result?.mpRes?.currency_id || result?.mpRes?.purchase_units[0]?.amount?.currency_code}</Typography>
                <Typography><strong>Método de pago:</strong> {result?.mpRes?.payment_method_id
                }</Typography>
                <Typography><strong>Email pagador:</strong> {result?.mpRes?.payer?.email || result?.mpRes?.payer?.email_address}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {result?.mpRes?.additional_info?.items?.[0]?.picture_url && (
                  <img
                    src={result?.mpRes?.additional_info.items[0]?.picture_url}
                    alt="Imagen del producto"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                )}
              </Grid>
            </Grid>
          </Paper>

          <Typography variant="h6" gutterBottom>
            📦 Información guardada localmente
          </Typography>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography><strong>Producto:</strong> {result?.storedPayment?.data?.payment?.orders?.orderProduct?.product?.name}</Typography>
            <Typography><strong>Descripción:</strong> {result?.storedPayment?.data?.payment?.orders?.orderProduct?.product?.description}</Typography>
            <Typography><strong>Precio:</strong> ${result?.storedPayment?.data?.payment?.orders?.orderProduct?.product?.price}</Typography>
            <Typography><strong>Estado:</strong> {result?.storedPayment?.data?.payment?.status}</Typography>
            <Typography><strong>Fecha:</strong> {new Date(result?.storedPayment?.data?.payment?.createdAt).toLocaleString()}</Typography>
          </Paper>
        </>
      ) : (
        <>
          {alert ? <Alert icon={<CloseIcon fontSize="inherit" />} severity="error" >
            {alertDescription}
          </Alert> : <Typography variant="body2" color="text.secondary">
            Ingresá un ID de pago para obtener la información.
          </Typography>}
        </>
      )}
    </Box>
  );
}

export { MercadoPagoApi };
